'use client';

import styled from 'styled-components';

import { theme } from '../theme';

export const RedDot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: var(${theme.radius.full});
  background-color: var(${theme.primary1});
`;
